import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { CargoHistoricoLstComponent } from './cargo-historico-lst/cargo-historico-lst.component';

const routes: Routes = [
  {
    path: 'pesquisa/:pagina',
    component: CargoHistoricoLstComponent, canActivate: [AuthGuard]
  },
  {
    path: 'pesquisa/:pagina/:filtro',
    component: CargoHistoricoLstComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CargoHistoricoRoutingModule { }

